import React, { useEffect, useMemo } from 'react';
import { LeftSidebar } from './../LeftSidebar';
import SnackbarUtils from 'utils/SnackbarUtils';
import { ModalManager } from '../ModalManager';
import { TooltipManager } from '../TooltipManager';
import { useSnackbar } from 'notistack';
import styles from './Layout.scss';
import { useLocation } from 'react-router-dom';
import { useAlert } from 'contexts/alert/AlertContext';
import { AlertCard } from 'components/AlertCard/AlertCard';
import Navbar from 'components/Navbar/Navbar';

const rootClassName = styles.rootClassName;

const Layout = (props) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const location = useLocation();
  const { showAlert } = useAlert();

  const AllowedRoutes = useMemo(() => [
    '/programaseducacionais/admin/projetos/pufv',
    '/programaseducacionais/admin/professores',
    '/programaseducacionais/admin/assessores',
    '/programaseducacionais/admin/coordenadores',
    '/programaseducacionais/admin/escolas',
    '/programaseducacionais/admin/empresas',
    '/programaseducacionais/admin/contratos',
    '/programaseducacionais/admin/relatorios',
    '/programaseducacionais/admin/materiais-pedagogicos',
    '/programaseducacionais/admin/materiais-pedagogicos/uniao-faz-a-vida',
    '/programaseducacionais/admin/materiais-pedagogicos/cooperativas-escolares',
    '/programaseducacionais/admin/materiais-pedagogicos/jornada-educacao-financeira',
    '/programaseducacionais/admin/agenda-assessores-pedagogicos',
    '/programaseducacionais/admin/dashboard',
  ], []);

  const checkRoutes = useMemo(() =>
    AllowedRoutes.includes(location.pathname) && showAlert,
    [AllowedRoutes, location.pathname, showAlert]);

  const containerClass = useMemo(() => checkRoutes
    ? `${rootClassName}-layout-container flex-direction-column`
    : `${rootClassName}-layout-container`, [checkRoutes]);

  useEffect(() => {
    SnackbarUtils.setSnackBar(enqueueSnackbar, closeSnackbar);
  }, [enqueueSnackbar, closeSnackbar]);

  return (
    <>
      <LeftSidebar />
      <Navbar className='z-depth-1' />
      {checkRoutes && <AlertCard showAlert={showAlert} />}
      <div className={containerClass}>{props.children}</div>
      <ModalManager />
      <TooltipManager />
    </>
  );
};

export default Layout;